module.exports = __webpack_public_path__ + "static/media/no-results-illustration.87a8a3d1.svg";